import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { courseApi } from '../api/client';
import { Course } from '../types';
import { BookOpen, Star, Flame, Trophy } from 'lucide-react';
import { flashcardApi } from '../api/client';
import { Brain } from 'lucide-react';

export function DashboardPage() {
  const { user }                            = useAuth();
  const [enrollments, setEnrollments]       = useState<Course[]>([]);
  const [loading, setLoading]               = useState(true);
  const [dueCards, setDueCards] = useState(0);

  useEffect(() => {
    async function load() {

      try {
  const dueRes = await flashcardApi.getDueCount();
  setDueCards(dueRes.data.dueCount);
} catch {
  // not critical
}

      try {
        const res = await courseApi.myEnrollments();
        setEnrollments(res.data);
      } catch (error: any) {
  if (error.response?.status === 401 || error.response?.status === 403) {
    return;
  }
  // not enrolled in anything yet — fine
} finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      {/* Welcome banner */}
      <div className="bg-gradient-to-r from-green-400/10 to-blue-500/10
                      border border-green-400/20 rounded-2xl p-6 mb-8">
        <h1 className="text-2xl font-black text-white mb-1">
          Welcome back, {user?.fullName?.split(' ')[0]}! 👋
        </h1>
        <p className="text-gray-400 text-sm">
          Ready to learn something amazing today?
        </p>
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {[
          { icon: Brain, label: 'Cards to Review', value: dueCards, color: 'text-purple-400' },
          { icon: BookOpen, label: 'Enrolled Courses', value: enrollments.length, color: 'text-blue-400' },
          { icon: Flame,    label: 'Day Streak',        value: '1',                color: 'text-orange-400' },
          { icon: Star,     label: 'Total XP',          value: '50',               color: 'text-yellow-400' },
          { icon: Trophy,   label: 'Level',             value: '1',                color: 'text-purple-400' },
        ].map(stat => (
          <div key={stat.label}
               className="bg-gray-900 border border-gray-800
                          rounded-xl p-4 text-center">
            <stat.icon className={`mx-auto mb-2 ${stat.color}`} size={24} />
            <div className="text-2xl font-black text-white">
              {stat.value}
            </div>
            <div className="text-xs text-gray-500 mt-1">{stat.label}</div>
          </div>
        ))}
      </div>

      {/* My courses */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-white">My Courses</h2>
          <Link to="/courses"
                className="text-green-400 hover:text-green-300
                           text-sm transition-colors">
            Browse all →
          </Link>
        </div>

        {loading ? (
          <div className="text-gray-500 text-sm">Loading...</div>
 ) : enrollments.length === 0 ? (
  <div className="bg-gray-900 border border-gray-800
                  rounded-2xl p-10 text-center">
    <div className="text-5xl mb-4">🎓</div>
    <h3 className="text-white font-bold text-lg mb-2">
      Welcome to EduNex!
    </h3>
    <p className="text-gray-400 text-sm mb-2">
      You have not enrolled in any courses yet.
    </p>
    <p className="text-gray-500 text-xs mb-6">
      Browse available courses and click Enroll Now to get started.
      Your XP, streaks and progress will appear here once you begin.
    </p>
    <Link
      to="/courses"
      className="bg-green-400 text-gray-950 font-bold
                 px-8 py-3 rounded-xl hover:bg-green-300
                 transition-colors text-sm inline-block"
    >
      Browse Courses →
    </Link>
  </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {enrollments.map(course => (
              <div key={course.id}
                   className="bg-gray-900 border border-gray-800
                              rounded-xl p-5 hover:border-green-400/40
                              transition-colors cursor-pointer">
                <div className="text-xs text-green-400 font-semibold mb-2">
                  {course.subject} · Grade {course.grade}
                </div>
                <h3 className="font-bold text-white mb-3 text-sm leading-snug">
                  {course.title}
                </h3>
                <div className="text-xs text-gray-500">
                  by {course.createdByName}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}